import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'classnames';
const Card = ({ children, className = '' }) => {
    return (_jsx("div", { className: "mx-auto", children: _jsx("div", { className: cx('g-gray flex-column flex-1 overflow-hidden bg-white shadow dark:bg-gray-700 sm:rounded-lg', { [className]: className.length }), children: children }) }));
};
const Header = ({ children, className = '', }) => {
    return (_jsx("div", { className: cx('bg-gray-200 px-4 py-4 dark:bg-gray-800 sm:px-6', {
            [className]: className.length,
        }), style: { justifyContent: 'space-between', alignItems: 'stretch' }, children: children }));
};
const Body = ({ children }) => {
    return _jsx("div", { className: "p-4", children: children });
};
export default Object.assign(Card, {
    Header,
    Body,
});
